import { render } from "./Moduletitle.vue?vue&type=template&id=b17cef8c&scoped=true&ts=true"
import script from "./Moduletitle.vue?vue&type=script&lang=ts"
export * from "./Moduletitle.vue?vue&type=script&lang=ts"

import "./Moduletitle.vue?vue&type=style&index=0&id=b17cef8c&lang=less&scoped=true"

import exportComponent from "/root/.jenkins/workspace/production-Q-saas-plat-manage-vue/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b17cef8c"]])

export default __exports__